/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from "react";
import HPLogo from "./hrvatskaPosta-logo.png";
import PostaInfo from "./postaInfo-icon.png";
import Line from "../../common/line/Line";
import { Row, Column } from "../../common/columns";
import { useTranslation } from "react-i18next";
import { UserContext } from "../../common/user/UserContext";
import { ThemeContext } from "../../common/theme/ThemeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone, faBookOpen } from "@fortawesome/free-solid-svg-icons";

function Footer() {
  const { t } = useTranslation();
  const user = useContext(UserContext);
  const theme = useContext(ThemeContext);

  const email = "hkms@hkms.hr";
  const telephoneNumber = "+385 1 2444 303";

  let domain = process.env.REACT_APP_DOCUMENTS_BASE_URL;
  let instructionsPath = "/user/ehkms_info/templates/Korisnicke_upute_eHKMS_-_Portal_2.0.pdf";
  let downloadUrl = domain + instructionsPath;
  // console.log(domain); POCISTITI KAD DODE S API-JA, finalna verzija

  // let urlArray = domain.split(":");
  // // console.log(urlArray);

  // downloadUrl = `${urlArray[0]}:${urlArray[1]}${instructionsPath}`;

  // console.log(downloadUrl);

  // BILA JE PROVJERA FOOTER-V1?, VIDI AKO DOBIJES V3? . DOLE JE PRIMJER KAKO JE PRIJE RADILO
  if (theme.themeColor === "purple") {
    if (theme.footer === true) {
      return (
        <footer className="hero-foot">
          <Line height={5} color={theme.iconColor} />
          {theme.footerVersion === "v1" ? (
            <Line height={8} color={theme.footerLineColor} /> //.lineColor
          ) : (
            <Line height={23} color={theme.footerLineColor} />
          )}
          <div className="p-3 has-background-black">
            <Row className="is-justify-content-center ">
              <Column className="is-5 has-text-white has-text-left-desktop has-text-centered-touch  ">
                <ul className="level">
                  <li>
                    <span className="icon mr-2">
                      <FontAwesomeIcon icon={faBookOpen} />
                    </span>
                    <a
                      className="is-link has-text-white has-background-black"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={downloadUrl} // NOVI LINK
                    >
                      {t("userSupport.instructions")}
                    </a>
                  </li>
                  <li>
                    <span className="icon mr-2">
                      <FontAwesomeIcon icon={faEnvelope} />
                    </span>
                    <a
                      className="is-link has-text-white has-background-black"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {`${t("userSupport.email")} ${email}`}
                    </a>
                  </li>
                  <li>
                    <span className="icon mr-2">
                      <FontAwesomeIcon icon={faPhone} />
                    </span>
                    <a
                      className="is-link has-text-white has-background-black"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {`${t("userSupport.telephone")} ${telephoneNumber}`}
                    </a>
                  </li>
                </ul>
              </Column>
            </Row>
          </div>
        </footer>
      );
    } else {
      return (
        <footer className="hero-foot">
          <div className="has-background-black">
            <div className="has-text-centered has-text-white">
              ©2021 All rights reserved by Dokument IT d.o.o.
            </div>
          </div>
          <Line height={8} color={theme.iconColor} />
        </footer>
      );
    }
  }

  if (theme.footer === true) {
    return (
      <footer className="hero-foot">
        <Line height={5} color={theme.iconColor} />
        {theme.footerVersion === "v1" ? (
          <Line height={8} color={theme.footerLineColor} /> //.lineColor
        ) : (
          <Line height={23} color={theme.footerLineColor} />
        )}
        <div className="p-3 has-background-black">
          {theme.footerVersion === "v1" ? (
            <Row>
              <Column className="is-4 has-text-right-desktop has-text-centered-touch">
                <img src={PostaInfo} alt="PostaInfo" />
              </Column>
              <Column className="is-2 has-text-white has-text-right-desktop has-text-centered-touch">
                <ul>
                  <li>
                    <a
                      className="is-link has-text-white has-background-black"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={user.applicationConfiguration.externalLinks.userSupport.instructions}
                    >
                      {t("userSupport.instructions")}
                    </a>
                  </li>
                  <li>{t("userSupport.title").toUpperCase()}</li>
                  <li>
                    <a
                      className={`is-link has-text-${theme.iconColor} has-background-black`}
                      href={`tel:+${t("userSupport.tel")}`}
                    >
                      {t("userSupport.tel")}
                    </a>
                  </li>
                </ul>
              </Column>
              <hr className={`has-background-${theme.lineColor} is-hidden-desktop`} />
              <Column className="is-2 has-text-white has-text-left-desktop has-text-centered-touch">
                <ul>
                  <li>
                    <a
                      className="is-link has-text-white has-background-black"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={user.applicationConfiguration.externalLinks.userSupport.usageTerms}
                    >
                      {t("userSupport.usageTerms")}
                    </a>
                  </li>
                  <li>
                    <a
                      className="is-link has-text-white has-background-black"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={user.applicationConfiguration.externalLinks.userSupport.faq}
                    >
                      {t("userSupport.FAQ")}
                    </a>
                  </li>
                  <li>
                    <a
                      className="is-link has-text-white has-background-black"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={user.applicationConfiguration.externalLinks.userSupport.contact}
                    >
                      {t("userSupport.contact")}
                    </a>
                  </li>
                  <li>
                    <a
                      className="is-link has-text-white has-background-black"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={
                        user.applicationConfiguration.externalLinks.userSupport
                          .generalTermsAndPrices
                      }
                    >
                      {t("userSupport.generalTermsAndPrices")}
                    </a>
                  </li>
                </ul>
              </Column>
              <Column className="is-4 has-text-left-desktop has-text-centered-touch">
                <img src={HPLogo} alt="HPLogo" />
              </Column>
            </Row>
          ) : (
            <Row className="is-justify-content-center ">
              {/* <Column className="is-4 has-text-right-desktop has-text-centered-touch">
                <img src={HPLogo} alt="PostaInfo" />
              </Column> */}
              <Column className="is-5 has-text-white has-text-left-desktop has-text-centered-touch  ">
                <ul className="level">
                  <li>
                    <a
                      className="is-link has-text-white has-background-black"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={user.applicationConfiguration.externalLinks.userSupport.usageTerms}
                    >
                      {t("userSupport.usageTerms")}
                    </a>
                  </li>
                  <li>
                    <a
                      className="is-link has-text-white has-background-black"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={user.applicationConfiguration.externalLinks.userSupport.faq}
                    >
                      {t("userSupport.FAQ")}
                    </a>
                  </li>
                  <li>
                    <a
                      className="is-link has-text-white has-background-black"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={user.applicationConfiguration.externalLinks.userSupport.contact}
                    >
                      {t("userSupport.contact")}
                    </a>
                  </li>
                  <li>
                    <a
                      className="is-link has-text-white has-background-black"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={
                        user.applicationConfiguration.externalLinks.userSupport
                          .generalTermsAndPrices
                      }
                    >
                      {t("userSupport.generalTermsAndPrices")}
                    </a>
                  </li>
                </ul>
              </Column>
            </Row>
          )}
        </div>
      </footer>
    );
  } else {
    return (
      <footer className="hero-foot">
        <div className="has-background-black">
          <div className="has-text-centered has-text-white">
            ©2021 All rights reserved by Dokument IT d.o.o.
          </div>
        </div>
        <Line height={8} color={theme.iconColor} />
      </footer>
    );
  }
}

export default Footer;
